import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { of as observableOf, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IMailTrackingSettings } from './mailtrackingsettings-model';

@Injectable()
export class MailTrackingSettingsService {
    constructor(private readonly http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'mailtrackingsettings';

    /** GET */
    public getMailTrackingSettings(): Observable<SuccessResponse<IMailTrackingSettings> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IMailTrackingSettings>>(
                MailTrackingSettingsService.URL +
                MailTrackingSettingsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** PUT */
    public updateMailTrackingSettings(settings: IMailTrackingSettings): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                MailTrackingSettingsService.URL +
                MailTrackingSettingsService.ENDPOINT,
                settings
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
